/* eslint-disable @typescript-eslint/naming-convention */
import { inject, Pipe, PipeTransform } from '@angular/core';
import { AuthService, ExternalLink, LinksService } from '@isophi/core-legacy';

import { RouterLinkFactory } from '../../core/router/router-link.factory';
import { KindergartenService } from '../../core/services/kindergarten.service';

export type PreparedLink = string[] | ExternalLink;

@Pipe({
    name: 'prepareLinks',
    standalone: false
})
export class PrepareLinksPipe implements PipeTransform {
  private readonly linksService = inject(LinksService);

  private readonly kindergartenService = inject(KindergartenService);

  private readonly authService = inject(AuthService);

  targetTypesLinks = {};

  constructor(private links: RouterLinkFactory) {
    let isophiTeacherUrl: ExternalLink | null = null;

    if (
      this.kindergartenService.loggedKindergarten.isKindergarten() &&
      (this.authService.loggedUser.teacher.isManager() || this.authService.loggedUser.teacher.isDirector())
    ) {
      isophiTeacherUrl = this.linksService.getManagementAppUrl({ redirect: '/pap/portfolio', queryParams: { source: 'tapp' } });
    } else {
      isophiTeacherUrl = this.linksService.getPapAppUrl({ redirect: '/info/dashboard' });
    }
    this.targetTypesLinks = {
      diagnostics_external: this.linksService.getDadAppUrl({ queryParams: { source: 'tapp' } }),
      children_and_results: this.links.childList(),
      dashboard: this.links.homepage(),
      children_groups: this.links.groupReportProblematicCategories(),
      children_group_list: this.links.groupList(),
      children_archive: this.links.childArchive(),
      materials: this.links.materialsEducational(),
      'materials-diagnostic': this.links.materialsDiagnostic(),
      'materials-educational': this.links.materialsEducational(),
      materials_diagnostic: this.links.materialsDiagnostic(),
      materials_educational: this.links.materialsEducational(),
      manuals: this.links.manuals(),
      game: this.links.games(),
      smart: this.links.games(),
      smart_promo: this.linksService.mockAppUrl('https://isophi.cz/smart'),
      isophi_teacher: isophiTeacherUrl,
      e_learning: [],
      teacher_management: this.links.teacherList(),
      isophi_management: this.linksService.getManagementAppUrl({ queryParams: { source: 'tapp' } }),
      portfolio: this.linksService.getManagementAppUrl({ redirect: '/children-portfolio/dashboard', queryParams: { source: 'tapp' } }),
    } as Record<string, PreparedLink>;
  }

  transform(targetType: string): PreparedLink {
    return this.targetTypesLinks[targetType];
  }
}
